import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import i18n from 'modules/core/lib/i18n'

import ArchiveCategoryModal from 'modules/time_categories_settings/components/WorkTimeCategories/ArchiveModal'
import CategoryModal from 'modules/time_categories_settings/components/WorkTimeCategories/CategoryModal'
import { CustomTimeRangeCategory } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'
import type { CustomTimeRangeCategoryFormType } from 'modules/time_categories_settings/lib/forms/CreateCustomTimeRangeCategoryForm'
import EditCustomTimeRangeCategoryForm from 'modules/time_categories_settings/lib/forms/EditCustomTimeRangeCategoryForm'

import CategoryMenu from './Menu'

interface Props {
  category: CustomTimeRangeCategory
}

const CategoryCard = ({ category }: Props) => {
  const [modalOpen, setModalOpen] = React.useState(false)
  const [archiveModalOpen, setArchiveModalOpen] = React.useState(false)

  const tagConfig = {
    ['overtime']: {
      color: Tag.Types.tangerine,
      text: i18n.t('time_categories.overtime'),
    },
    ['regular']: {
      color: Tag.Types.grey,
      text: i18n.t('time_categories.regular'),
    },
    ['any_time']: {
      color: Tag.Types.purple,
      text: i18n.t('time_categories.any_time'),
    },
  }

  const timeType = tagConfig[category.timeType]
  const form = EditCustomTimeRangeCategoryForm({
    category,
    setModalOpen,
  }) as FormikProps<CustomTimeRangeCategoryFormType>

  return (
    <Box
      width="full"
      component="ul"
      borderRadius={{ all: 'abs008' }}
      border={{
        all: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
      gapDivider
    >
      <Box
        component="li"
        flexDirection="row"
        justifyContent="spaceBetween"
        paddingY="s16"
        paddingX="s24"
        alignItems="center"
      >
        <Text size="300" weight="medium">
          {category.name}
        </Text>
        <Box flexDirection="row" alignItems="center" gap="s16">
          <Tag type={timeType.color}>{timeType.text}</Tag>
          <CategoryMenu setModalOpen={setModalOpen} setArchiveModalOpen={setArchiveModalOpen} />
        </Box>
        {modalOpen && <CategoryModal actionType="update" setModalOpen={setModalOpen} form={form} />}
        {archiveModalOpen && (
          <ArchiveCategoryModal
            categoryId={category.id}
            name={category.name}
            archived={category.archived}
            setArchiveModalOpen={setArchiveModalOpen}
          />
        )}
      </Box>
    </Box>
  )
}

export default CategoryCard
